<template>
	<reportFormWrap
		ref="reportFormWrap"
		:reportid="reportid"
		:orderMenu="orderMenu"
		:settingCols="settingCols"
		:getFiltersParams="getFiltersParams"
		:reportFormUrl="reportFormUrl"
		:getCustomThroughParams="getCustomThroughParams">
		<FiltersBox slot="filters" ref="filters" @inputEnter='inputEnter'></FiltersBox>
	</reportFormWrap>
</template>

<script>
import { cols } from '@/js/reportformSupply/saleOrder.js'
import { orderMenu } from '@/js/reportformSupply/reportformCommon.js'
import reportFormWrap from '@/components/reportform/common/ReportFormWrap.vue'
import FiltersBox from '@/components/reportformSupply/saleOrder/FiltersBox.vue'
import { mixinReportAuth } from '@/js/mixins/reportform/authComp.js'
export default {
	name: 'MidSaleOrder',
	components: {
		reportFormWrap,
		FiltersBox
	},
	mixins: [mixinReportAuth],
	data () {
		return {
			reportid: 'MID_DPDD_121010',
			settingCols: cols,
			reportFormUrl: `${this.$fxBaseApi.urlNVPM}/reportScheme/midShopSaleOrderReport`,
			orderMenu: orderMenu
		}
	},
	mounted () {
		this.$refs.reportFormWrap.initReportForm()
	},
	methods: {
		inputEnter () {
			return this.$refs.reportFormWrap.searchHandler()
		},
		getFiltersParams () {
			return this.$refs.filters.getFiltersParams()
		},
		getCustomThroughParams () {
			return this.$refs.filters.getFiltersDate()
		}
	}
}
</script>
